// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subISOWeekYears as fn } from "../subISOWeekYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subISOWeekYearsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subISOWeekYearsWithOptions;
